import { Component, Object3D, Property } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';

export interface AvatarCatalogEntry {
    id: string;
    label: string;
    templateName: string;
}

export class AvatarCatalogEntryDefinition {
    @property.string()
    id: string = '';

    @property.string()
    label: string = '';

    @property.string()
    templateName: string = '';
}

export class AvatarController extends Component {
    static TypeName = 'avatar-controller';

    static instance: AvatarController | null = null;

    @property.object()
    avatarTemplates!: Object3D;

    @property.array(Property.record(AvatarCatalogEntryDefinition))
    avatars: AvatarCatalogEntry[] = [];

    get templateRoot(): Object3D | null {
        return this.avatarTemplates && !this.avatarTemplates.isDestroyed ? this.avatarTemplates : null;
    }

    init(): void {
        if (AvatarController.instance && AvatarController.instance !== this) {
            console.warn('[AvatarController] Multiple AvatarController instances detected; keeping the most recent one.');
        }
        AvatarController.instance = this;
    }

    override onDestroy(): void {
        if (AvatarController.instance === this) {
            AvatarController.instance = null;
        }
    }

    get entries(): AvatarCatalogEntry[] {
        return Array.isArray(this.avatars) ? this.avatars.filter((entry) => !!entry && typeof entry.id === 'string' && typeof entry.label === 'string' && typeof entry.templateName === 'string') : [];
    }
}
